const api = process.env.REACT_APP_API_URL;

export const urls = {
	userCountries: `${api}GetUserCountries?`,
	groupStatus: `${api}PGCGApproval/GetStatus`,
	periods: `${api}PGCGApproval/GetPeriods`,
	productGroups: `${api}ProductGroup/GetProductGroupsWithStatus`,
	customerGroups: `${api}CustomerGroup/GetCstmrGrpWithStatus`,
	rejectApproveProductGroup: `${api}ProductGroup/ApproveProductGroup`,
   rejectApproveCustomerGroup: `${api}CustomerGroup/ApproveCstmrGrp`,
   approveRejectMultiPG: `${api}ProductGroup/ApproveProductMultiple`,
   approveRejectMultiCG: `${api}CustomerGroup/ApproveCustomerMultiple`,
};

export const views = [
	{ key: 1, value: "Product Group" },
	{ key: 2, value: "Customer Group" },
];

export function getProductGroupsTable(data) {
	const rows = getProductGroupsRow(data);
	return { rows };
}

function getProductGroupsRow(data) {
	return data.map((item) => {
		return {
			id: item.productGroupID,
			productGroupName: item.productGroupName,
			countryCode: item.countryCode,
			status: item.status,
			updatedDate: item.updatedDate,
			updatedBy: item.updatedBy,
		};
	});
}

export function getCustomerGroupsTable(data) {
	const rows = getCustomerGroupsRow(data);
	return { rows };
}



function getCustomerGroupsRow(data) {
	return data.map((item) => {
		return {
			id: item.customerGroupID,
			customerGroupName: item.customerGroupName,
			countryCode: item.countryCode,
			status: item.status,
			updatedDate: item.updatedDate,
			updatedBy: item.updatedBy,
		};
	});
}
